'use client';

import classnames from 'classnames';
import { IoInformationCircleOutline } from 'react-icons/io5';

import { Icon } from '../icon';
import { Loading } from '../loading';
import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip';
import type { CardProps } from './Card.types';

import styles from './Card.module.scss';

function Card({
  style,
  className,
  icon,
  title,
  caption,
  tooltip,
  actions,
  children,
  image,
  loading = false,
  testId = 'ui-card',
}: CardProps) {
  return (
    <div
      style={style}
      className={classnames(styles['card'], className)}
      data-testid={testId}
    >
      {(icon || title || caption || tooltip || actions) && (
        <div className={styles['header']}>
          <div className={styles['title']}>
            {icon && <div className={styles['icon']}>{icon}</div>}
            {title && (
              <span className={styles['text']} data-testid={`${testId}_title`}>
                {title}
              </span>
            )}
          </div>
          <div className={styles['caption-wrapper']}>
            {caption && (
              <div
                className={styles['caption']}
                data-testid={`${testId}_caption`}
              >
                {caption}
              </div>
            )}
            {tooltip && (
              <Tooltip>
                <TooltipTrigger asChild={true}>
                  <Icon
                    className={styles['tooltip']}
                    icon={<IoInformationCircleOutline />}
                    size="sm"
                  />
                </TooltipTrigger>
                <TooltipContent className={styles['tooltip-content']}>
                  {tooltip}
                </TooltipContent>
              </Tooltip>
            )}
            {actions}
          </div>
        </div>
      )}
      {loading ? (
        <div className={styles['loading-wrapper']}>
          <Loading />
        </div>
      ) : (
        <>
          {children}
          {image && (
            <div className={styles['image-wrapper']} aria-hidden="true">
              <img
                className={styles['image']}
                src={image}
                alt=""
                data-testid={`${testId}_image`}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export { Card };
